import { Icon, IconProps } from "@smartsheet/lodestar-icons";
import React, { FC } from "react";

/**
 * Programmatically convert a svg string into a Icon function component without using JSX
 * @deprecated please use the Icon component from `@smartsheet/lodestar-icons`.
 */
// eslint-disable-next-line react/display-name
export const convertToIcon: (svg: string) => FC<IconProps> = (svg) => (props) =>
    <Icon dangerouslySetSvg={svg} {...props} />;
